import React, { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { SampleRequestService } from '../../../Services/SampleRequest.Service';
import { format } from 'date-fns';
// Validation schema using Yup
const validationSchema = Yup.object({
    pickedUpBy: Yup.string().required('Please enter name'),
    pickupDate: Yup.date().required('Please select date'),
    pickupTime: Yup.string().required('Please select time'),
});

const PickupDetailsModal = ({ show, onHide, onConfirm, title = "Pick Up Details", request_id, duration, sample_count, status,sample }) => {
    const [initialValues, setInitialValues] = useState({
        pickedUpBy: null,
        pickupDate: null,
        pickupTime: null,
    });
    useEffect(() => {
        if (show && request_id && sample?.lab_id) {
            // Generate 30-minute intervals for a 24-hour day
            const generateTimeSlots = () => {
                const slots = [];
                for (let hour = 0; hour < 24; hour++) {
                    for (let minute = 0; minute < 60; minute += 30) {
                        // Ensure hour and minute are padded to two digits
                        const formattedTime = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
                        slots.push(formattedTime);
                    }
                }
                return slots;
            };
    
            const timeSlots = generateTimeSlots();
            setPickupTimes(timeSlots);
        }
    }, [show, request_id, sample, sample_count]);
    
    const [pickupTimes, setPickupTimes] = useState([]);
    useEffect(() => {
        if (show && request_id && sample.lab_id) {
           
            // const getPickupTimeSchedule = {
            //     lab_id: sample.lab_id,
            //     duration: duration,
            //     // start_date: "November 4, 2024"
            //     sample_count: sample_count
            // }
            // SampleRequestService.getPickupTimeSchedule(getPickupTimeSchedule)
            //     .then(data => {
            //         setPickupTimes(data.pickup_time.map(time => time.slice(0, 5)) || []);
            //     })
            //     .catch(error => {
            //         console.error('Error fetching pickup time schedule:', error);
            //     });


            SampleRequestService.getPickupDetails(request_id)
                .then(data => {
                    // Format the time to "HH:mm"
                    const formattedTime = data.details.pickup_time
                        ? data.details.pickup_time.slice(0, 5) // This will extract the first 5 characters ("13:00")
                        : null;

                    setInitialValues({
                        pickedUpBy: data.details.pickup_by || null,
                        pickupDate: data.details.pickup_date ? new Date(data.details.pickup_date) : null,
                        pickupTime: formattedTime || null,
                    });
                })
                .catch(error => {
                    console.error('Error fetching pickup details:', error);
                });





        }
    }, [show, request_id]);


    return (
        <Modal show={show} centered onHide={onHide} dialogclassname="el-deactivate-modal" backdrop="static">
            <Modal.Body>
                <h5 className='mb-4'>{title}</h5>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        const formattedValues = {
                            ...values,
                            pickupDate: values.pickupDate
                                ? format(new Date(values.pickupDate), 'yyyy-MM-dd')
                                : null,
                        };
                        onConfirm(formattedValues);
                        setSubmitting(false);
                    }}
                >
                    {({ values, setFieldValue, isSubmitting }) => (
                        <Form>
                            <div className="form-group mb-3">
                                <label htmlFor="pickedUpBy">Picked Up By:</label>
                                <Field
                                    type="text"
                                    name="pickedUpBy"
                                    className="form-control"
                                    placeholder="Type here"
                                />
                                <ErrorMessage name="pickedUpBy" component="div" className="text-danger" />
                            </div>

                            <Row className="mb-3">
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>Pickup Date:</label>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                value={values.pickupDate}
                                                onChange={(date) => setFieldValue('pickupDate', date)}
                                                minDate={new Date()}  
                                                renderInput={(props) => (
                                                    <TextField {...props} className="form-control" fullWidth />
                                                )}
                                            />
                                        </LocalizationProvider>
                                        <ErrorMessage name="pickupDate" component="div" className="text-danger" />
                                    </div>
                                </Col>
                                {/* <Col md={6}>
                                    <div className="form-group">
                                        <label>Pickup Time:</label>
                                        <Field
                                            as="select"
                                            name="pickupTime"
                                            className="form-select"
                                        >
                                            <option value="">Select time</option>
                                            {pickupTimes.length > 0 ? (
                                                pickupTimes.map((time, index) => (
                                                    <option key={index} value={time}>
                                                        {time}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="">No times available</option>
                                            )}
                                        </Field>
                                        <ErrorMessage name="pickupTime" component="div" className="text-danger" />
                                    </div>
                                </Col> */}
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>Pickup Time:</label>
                                        <Field
                                            as="select"
                                            name="pickupTime"
                                            className="form-select"
                                        >
                                            <option value="">Select time</option>
                                            {pickupTimes.length > 0 ? (
                                                pickupTimes.map((time, index) => {
                                                    const [hour, minute] = time.split(':').map(Number);
                                                    const ampm = hour >= 12 ? 'PM' : 'AM';
                                                    const formattedHour = hour % 12 || 12; // Convert 0 hour to 12 for 12-hour format
                                                    const displayTime = `${formattedHour}:${minute.toString().padStart(2, '0')} ${ampm}`;
                                                    return (
                                                        <option key={index} value={time}>
                                                            {displayTime}
                                                        </option>
                                                    );
                                                })
                                            ) : (
                                                <option value="">No times available</option>
                                            )}
                                        </Field>
                                        <ErrorMessage name="pickupTime" component="div" className="text-danger" />
                                    </div>
                                </Col>

                            </Row>

                            <div className="d-flex mt-3">
                                <button
                                    type="submit"
                                    className="btn el-main-button me-3"
                                    // status !== 7 || 
                                    disabled={isSubmitting || (status == 8)}
                                >
                                    <span>Mark "Picked Up"</span>
                                </button>
                                <button
                                    type="button"
                                    className="back-link ms-3"
                                    onClick={onHide}
                                >
                                    Close
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default PickupDetailsModal;
